<div>
  <small class="dica">
    Cada regra reformata um campo dos registros. Sem campo de destino, a regra sobrescreve o próprio campo. As regras rodam na ordem da lista.
  </small>

  <p class="text-500" *ngIf="model.regras.length === 0">Nenhuma regra de formatação. Use <strong>Adicionar regra</strong> para definir a primeira.</p>

  <div class="regra" *ngFor="let r of model.regras; let i = index" [attr.id]="'regra' + i">
    <div class="cabecalho">
      <strong>Regra {{ i + 1 }}</strong>
      <span class="text-500" *ngIf="destinoDaRegra(r)">grava em {{ destinoDaRegra(r) }}</span>
      <span class="flex-grow-1"></span>
      <p-button icon="pi pi-arrow-up" styleClass="p-button-rounded p-button-text p-button-sm" [disabled]="i === 0" (onClick)="mover(i, -1)" pTooltip="Subir"></p-button>
      <p-button icon="pi pi-arrow-down" styleClass="p-button-rounded p-button-text p-button-sm" [disabled]="i === model.regras.length - 1" (onClick)="mover(i, 1)" pTooltip="Descer"></p-button>
      <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger p-button-sm" (onClick)="remover(i)" pTooltip="Remover regra"></p-button>
    </div>

    <div class="linha">
      <input pInputText [attr.id]="'regraCampo' + i" [(ngModel)]="r.campo" placeholder="Campo (ex.: started)" style="min-width: 12rem" />
      <i class="pi pi-arrow-right text-500"></i>
      <input pInputText [attr.id]="'regraDestino' + i" [(ngModel)]="r.nomeDestino" placeholder="Destino (vazio = mesmo campo)" style="min-width: 14rem" />
      <p-dropdown [attr.id]="'regraTipo' + i" [options]="tipos" [(ngModel)]="r.tipo" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-16rem"></p-dropdown>
    </div>

    <!-- Datas -->
    <ng-container *ngIf="ehData(r.tipo)">
      <div class="linha">
        <p-dropdown [attr.id]="'regraOrigem' + i" [options]="padroesData" [(ngModel)]="r.formatoOrigem" [editable]="true" [showClear]="true" appendTo="body"
          placeholder="Formato de origem (vazio = detecta)" styleClass="w-18rem"></p-dropdown>
        <p-dropdown [attr.id]="'regraFormatoDestino' + i" [options]="padroesData" [(ngModel)]="r.formatoDestino" [editable]="true" [showClear]="true" appendTo="body"
          [placeholder]="'Formato de destino (vazio = ' + padraoDestino + ')'" styleClass="w-22rem"></p-dropdown>
        <input pInputText [attr.id]="'regraHora' + i" [(ngModel)]="r.horaFixa" placeholder="Hora fixa (HH:mm:ss)" style="width: 11rem" />
      </div>
      <small class="dica">Padrões no estilo Java (yyyy, MM, dd, HH, mm, ss); texto literal entre aspas simples. A hora fixa substitui a hora do valor (ex.: 07:00:00).</small>
    </ng-container>

    <!-- Números -->
    <ng-container *ngIf="ehNumero(r.tipo)">
      <div class="linha">
        <p-inputNumber [attr.id]="'regraCasas' + i" [(ngModel)]="r.casasDecimais" [showButtons]="false" [min]="0" [max]="18" [useGrouping]="false" placeholder="Casas decimais"></p-inputNumber>
        <p-dropdown [attr.id]="'regraArred' + i" [options]="arredondamentos" [(ngModel)]="r.arredondamento" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-20rem"></p-dropdown>
      </div>
      <small class="dica">Sem casas decimais, o número só perde os zeros à direita. O arredondamento vale quando há casas decimais.</small>
    </ng-container>

    <small class="dica aviso" *ngIf="r.tipo === 'TEXTO'" [attr.id]="'regraAvisoTexto' + i">
      <i class="pi pi-exclamation-triangle"></i> O tipo Texto não altera o valor (o backend só registra um aviso). Use Data ou Número, ou remova a regra.
    </small>
  </div>

  <p-button label="Adicionar regra" icon="pi pi-plus" styleClass="p-button-sm" (onClick)="adicionar()"></p-button>
</div>
